import icon from "~/components/ui/icons/svg/filter-icon.svg";

export const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <use xlinkHref={`#${icon}`} />
    </svg>
  );
};
